import DefaultProjectDetailView from "src/components/feature/ProjectDetailView/FundApplicationDetails";

const FundApplicationDetailView = () => {
  return <DefaultProjectDetailView />;
};

export default FundApplicationDetailView;
